import { getDocumentElements, getScrollTop, getScrollLeft } from '../utils'

const [rippleContainers] = getDocumentElements([{ className: 'tet-btn', getAllElements: true }])

const span = document.createElement('span')
span.setAttribute('class', 'inner')

const init = () => {
    if (rippleContainers) {
        const animateRipple = e => {
            e.target.querySelector('.inner') ? e.target.removeChild(e.target.querySelector('.inner')) : '' ;
            e.target.insertAdjacentHTML('afterbegin', span.outerHTML)

            const rippleEl = e.target.querySelector('.inner')

            const dimensions = Math.max(e.target.offsetHeight, e.target.offsetWidth)
            rippleEl.style.height = `${dimensions}px`
            rippleEl.style.width = `${dimensions}px`

            const rect = e.target.getBoundingClientRect()

            const offset = {
                top: rect.top + getScrollTop(),
                left: rect.left + getScrollLeft(),
            }

            const x = e.pageX - offset.left - rippleEl.offsetWidth / 2
            const y = e.pageY - offset.top - rippleEl.offsetHeight / 2

            rippleEl.style.top = `${y}px`
            rippleEl.style.left = `${x}px`

            e.target.blur();
        }

        Array.from(rippleContainers).map(rippleContainer => {
            rippleContainer.addEventListener('click', animateRipple)
        })
    }
}

export { init }
